import { render } from "./Tabs.vue?vue&type=template&id=5e09585a"
import script from "./Tabs.vue?vue&type=script&lang=ts"
export * from "./Tabs.vue?vue&type=script&lang=ts"
script.render = render

export default script